export default __webpack_public_path__ + "static/media/vehicle_details_active.2622a6f8.svg";